// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"commentary_summary-module__wrapper--1Uut7","content":"commentary_summary-module__content--8YlxM","more":"commentary_summary-module__more--28dEa"};